/* eslint-disable quote-props */

// LNF KG BOY is quadrupled based on OU update for BOY 2019 data issue
const MEASURE_WEIGHTS_MULTIPLIER_BY_GRADE_PERIOD = {
    'KG_BOY_LNF': 4,
};

const MEASURE_WEIGHTS_BY_GRADE = {
    'KG': {
        'LNF': 8.86,
        'PSF': 4.13,
        'NWF-CLS': 14.93,
        'NWF-WRC': 3.56,
        'WRF': 5.62,
    },
    '01': {
        'LNF': 10.72,
        'PSF': 2.13,
        'NWF-CLS': 23.13,
        'NWF-WRC': 7.79,
        'WRF': 13.51,
        'ORF': 25.36,
        'ORF-ACC': 0.25,
    },
    '02': {
        'NWF-CLS': 32.74,
        'NWF-WRC': 10.95,
        'WRF': 21.26,
        'ORF': 35.36,
        'ORF-ACC': 0.15,
        'MAZE': 4.28,

    },
    '03': {
        'NWF-CLS': 40.02,
        'NWF-WRC': 11.8,
        'WRF': 19.83,
        'ORF': 39.42,
        'ORF-ACC': 0.09,
        'MAZE': 4.79,
    },
    '04': {
        'ORF': 36.42,
        'ORF-ACC': 0.06,
        'MAZE': 6.29,
    },
    '05': {
        'ORF': 31.12,
        'ORF-ACC': 0.03,
        'MAZE': 4.58,
    },
    '06': {
        'ORF': 40.71,
        'ORF-ACC': 0.05,
        'MAZE': 5.03,
    },
    '07': {
        'ORF': 40.55,
        'ORF-ACC': 0.06,
        'MAZE': 7.34,
    },
    '08': {
        'ORF': 37.69,
        'ORF-ACC': 0.03,
        'MAZE': 6.75,
    },
};

const MEAN_BY_GRADE_PERIOD = {
    'KG': {
        'BOY': 729,
        'MOY': 729,
        'EOY': 729,
        'SUMMER': 729,
    },
    '01': {
        'BOY': 3371,
        'MOY': 3371,
        'EOY': 3371,
        'SUMMER': 3371,
    },
    '02': {
        'BOY': 7085,
        'MOY': 7085,
        'EOY': 7085,
        'SUMMER': 7085,
    },
    '03': {
        'BOY': 10051,
        'MOY': 10051,
        'EOY': 10051,
        'SUMMER': 10051,
    },
    '04': {
        'BOY': 4563,
        'MOY': 4563,
        'EOY': 4563,
        'SUMMER': 4563,
    },
    '05': {
        'BOY': 4085,
        'MOY': 4085,
        'EOY': 4085,
        'SUMMER': 4085,
    },
    '06': {
        'BOY': 6087,
        'MOY': 6087,
        'EOY': 6087,
        'SUMMER': 6087,
    },
    '07': {
        'BOY': 6444,
        'MOY': 6444,
        'EOY': 6444,
    },
    '08': {
        'BOY': 4824,
        'MOY': 4824,
        'EOY': 4824,
    },
};

// SD - Standard Deviation
const SD_BY_GRADE_PERIOD = {
    'KG': {
        'BOY': 630,
        'MOY': 630,
        'EOY': 630,
        'SUMMER': 630,
    },
    '01': {
        'BOY': 2251,
        'MOY': 2251,
        'EOY': 2251,
        'SUMMER': 2251,
    },
    '02': {
        'BOY': 3811,
        'MOY': 3811,
        'EOY': 3811,
        'SUMMER': 3811,
    },
    '03': {
        'BOY': 4349,
        'MOY': 4349,
        'EOY': 4349,
        'SUMMER': 4349,
    },
    '04': {
        'BOY': 1771,
        'MOY': 1771,
        'EOY': 1771,
        'SUMMER': 1771,
    },
    '05': {
        'BOY': 1299,
        'MOY': 1299,
        'EOY': 1299,
        'SUMMER': 1299,
    },
    '06': {
        'BOY': 1685,
        'MOY': 1685,
        'EOY': 1685,
        'SUMMER': 1685,
    },
    '07': {
        'BOY': 1960,
        'MOY': 1960,
        'EOY': 1960,
    },
    '08': {
        'BOY': 1506,
        'MOY': 1506,
        'EOY': 1506,
    },
};

const SCORE_OFFSET_CONSTANT_BY_GRADE_PERIOD = {
    'KG': {
        'BOY': 289, // fall
        'MOY': 364, // winter
        'EOY': 398, // spring
        'SUMMER': 398, // huh?
    },
    '01': {
        'BOY': 360, // fall
        'MOY': 400, // winter
        'EOY': 440, // spring
        'SUMMER': 440,
    },
    '02': {
        'BOY': 360, // fall
        'MOY': 400, // winter
        'EOY': 440, // spring
        'SUMMER': 440,
    },
    '03': {
        'BOY': 360, // fall
        'MOY': 400, // winter
        'EOY': 440, // spring
        'SUMMER': 440,
    },
    '04': {
        'BOY': 360, // fall
        'MOY': 400, // winter
        'EOY': 440, // spring
        'SUMMER': 440,
    },
    '05': {
        'BOY': 360, // fall
        'MOY': 400, // winter
        'EOY': 440, // spring
        'SUMMER': 440,
    },
    '06': {
        'BOY': 360, // fall
        'MOY': 400, // winter
        'EOY': 440, // spring
        'SUMMER': 440,
    },
    '07': {
        'BOY': 360, // fall
        'MOY': 400, // winter
        'EOY': 440, // spring
    },
    '08': {
        'BOY': 360, // fall
        'MOY': 400, // winter
        'EOY': 440, // spring
    },
};

const COMPOSITE_SCORE_MULTIPLIER = 40;


const SECURE_SCORE_TYPE = 'secure';
const REGULAR_SCORE_TYPE = 'regular';
const SCORE_TYPE_PRECEDENCE = [SECURE_SCORE_TYPE, REGULAR_SCORE_TYPE];

module.exports = {
    SECURE_SCORE_TYPE,
    REGULAR_SCORE_TYPE,
    SCORE_TYPE_PRECEDENCE,
    COMPOSITE_SCORE_MULTIPLIER,
    MEAN_BY_GRADE_PERIOD,
    MEASURE_WEIGHTS_BY_GRADE,
    MEASURE_WEIGHTS_MULTIPLIER_BY_GRADE_PERIOD,
    SCORE_OFFSET_CONSTANT_BY_GRADE_PERIOD,
    SD_BY_GRADE_PERIOD,
};
